var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _vm._m(0),
          _c("div", { staticClass: "card-body" }, [
            _vm.loading
              ? _c("div", { staticClass: "text-center" }, [_vm._m(1)])
              : _c("div", [
                  _c(
                    "form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.saveThemeColors($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "section" }, [
                        _c("h3", [_vm._v("Sidebar Colors")]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "sidbar_bg_color" } },
                                [_vm._v("Sidebar Background")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sidbar_bg_color,
                                      expression: "themeColors.sidbar_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sidbar_bg_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sidbar_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidbar_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sidbar_bg_color,
                                      expression: "themeColors.sidbar_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#1a1a1a"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sidbar_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidbar_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "sidbar_text_color" } },
                                [_vm._v("Sidebar Text")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sidbar_text_color,
                                      expression:
                                        "themeColors.sidbar_text_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sidbar_text_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sidbar_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidbar_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sidbar_text_color,
                                      expression:
                                        "themeColors.sidbar_text_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ffffff"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sidbar_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidbar_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "sidebar_item_color" } },
                                [_vm._v("Sidebar Item")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sidebar_item_color,
                                      expression:
                                        "themeColors.sidebar_item_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sidebar_item_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sidebar_item_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sidebar_item_color,
                                      expression:
                                        "themeColors.sidebar_item_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#cccccc"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sidebar_item_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "sidebar_item_hover_color" } },
                                [_vm._v("Sidebar Item Hover")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_hover_color,
                                      expression:
                                        "themeColors.sidebar_item_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sidebar_item_hover_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.sidebar_item_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_hover_color,
                                      expression:
                                        "themeColors.sidebar_item_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ffffff"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.sidebar_item_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "sidebar_item_active_color" } },
                                [_vm._v("Sidebar Item Active")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_active_color,
                                      expression:
                                        "themeColors.sidebar_item_active_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sidebar_item_active_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.sidebar_item_active_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_active_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_active_color,
                                      expression:
                                        "themeColors.sidebar_item_active_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#007bff"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.sidebar_item_active_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_active_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  attrs: {
                                    for: "sidebar_item_active_hover_color"
                                  }
                                },
                                [_vm._v("Sidebar Item Active Hover")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_active_hover_color,
                                      expression:
                                        "themeColors.sidebar_item_active_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sidebar_item_active_hover_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors
                                        .sidebar_item_active_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_active_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_active_hover_color,
                                      expression:
                                        "themeColors.sidebar_item_active_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#0056b3"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors
                                        .sidebar_item_active_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_active_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  attrs: { for: "sidebar_item_hover_bg_color" }
                                },
                                [_vm._v("Sidebar Item Hover Background")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_hover_bg_color,
                                      expression:
                                        "themeColors.sidebar_item_hover_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sidebar_item_hover_bg_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors
                                        .sidebar_item_hover_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_hover_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .sidebar_item_hover_bg_color,
                                      expression:
                                        "themeColors.sidebar_item_hover_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#2a2a2a"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors
                                        .sidebar_item_hover_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sidebar_item_hover_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "section" }, [
                        _c("h3", [_vm._v("Header Colors")]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "header_color" } }, [
                                _vm._v("Header Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.header_color,
                                      expression: "themeColors.header_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "header_color" },
                                  domProps: {
                                    value: _vm.themeColors.header_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "header_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.header_color,
                                      expression: "themeColors.header_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#333333"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.header_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "header_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "sub_header_color" } },
                                [_vm._v("Sub Header Color")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sub_header_color,
                                      expression: "themeColors.sub_header_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "sub_header_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sub_header_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sub_header_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.sub_header_color,
                                      expression: "themeColors.sub_header_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#666666"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.sub_header_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "sub_header_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "section" }, [
                        _c("h3", [_vm._v("Card Colors")]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "card_1_color" } }, [
                                _vm._v("Card 1 Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_1_color,
                                      expression: "themeColors.card_1_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "card_1_color" },
                                  domProps: {
                                    value: _vm.themeColors.card_1_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_1_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_1_color,
                                      expression: "themeColors.card_1_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#f8f9fa"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.card_1_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_1_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "card_2_color" } }, [
                                _vm._v("Card 2 Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_2_color,
                                      expression: "themeColors.card_2_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "card_2_color" },
                                  domProps: {
                                    value: _vm.themeColors.card_2_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_2_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_2_color,
                                      expression: "themeColors.card_2_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#e9ecef"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.card_2_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_2_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "card_3_color" } }, [
                                _vm._v("Card 3 Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_3_color,
                                      expression: "themeColors.card_3_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "card_3_color" },
                                  domProps: {
                                    value: _vm.themeColors.card_3_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_3_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_3_color,
                                      expression: "themeColors.card_3_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#dee2e6"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.card_3_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_3_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "card_4_color" } }, [
                                _vm._v("Card 4 Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_4_color,
                                      expression: "themeColors.card_4_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "card_4_color" },
                                  domProps: {
                                    value: _vm.themeColors.card_4_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_4_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_4_color,
                                      expression: "themeColors.card_4_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ced4da"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.card_4_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_4_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "card_5_color" } }, [
                                _vm._v("Card 5 Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_5_color,
                                      expression: "themeColors.card_5_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "card_5_color" },
                                  domProps: {
                                    value: _vm.themeColors.card_5_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_5_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_5_color,
                                      expression: "themeColors.card_5_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#adb5bd"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.card_5_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_5_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "card_6_color" } }, [
                                _vm._v("Card 6 Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_6_color,
                                      expression: "themeColors.card_6_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "card_6_color" },
                                  domProps: {
                                    value: _vm.themeColors.card_6_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_6_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.card_6_color,
                                      expression: "themeColors.card_6_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#6c757d"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.card_6_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "card_6_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "section" }, [
                        _c("h3", [_vm._v("Button Colors")]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "primary_button_bg_color" } },
                                [_vm._v("Primary Button Background")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.primary_button_bg_color,
                                      expression:
                                        "themeColors.primary_button_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "primary_button_bg_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.primary_button_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "primary_button_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.primary_button_bg_color,
                                      expression:
                                        "themeColors.primary_button_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#007bff"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.primary_button_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "primary_button_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "primary_button_text_color" } },
                                [_vm._v("Primary Button Text")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .primary_button_text_color,
                                      expression:
                                        "themeColors.primary_button_text_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "primary_button_text_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.primary_button_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "primary_button_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .primary_button_text_color,
                                      expression:
                                        "themeColors.primary_button_text_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ffffff"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.primary_button_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "primary_button_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "success_button_bg_color" } },
                                [_vm._v("Success Button Background")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.success_button_bg_color,
                                      expression:
                                        "themeColors.success_button_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "success_button_bg_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.success_button_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "success_button_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.success_button_bg_color,
                                      expression:
                                        "themeColors.success_button_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#28a745"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.success_button_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "success_button_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "success_button_text_color" } },
                                [_vm._v("Success Button Text")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .success_button_text_color,
                                      expression:
                                        "themeColors.success_button_text_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "success_button_text_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.success_button_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "success_button_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .success_button_text_color,
                                      expression:
                                        "themeColors.success_button_text_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ffffff"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.success_button_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "success_button_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "danger_button_bg_color" } },
                                [_vm._v("Danger Button Background")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.danger_button_bg_color,
                                      expression:
                                        "themeColors.danger_button_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "danger_button_bg_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.danger_button_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "danger_button_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.danger_button_bg_color,
                                      expression:
                                        "themeColors.danger_button_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#dc3545"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.danger_button_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "danger_button_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "danger_button_text_color" } },
                                [_vm._v("Danger Button Text")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .danger_button_text_color,
                                      expression:
                                        "themeColors.danger_button_text_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "danger_button_text_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.danger_button_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "danger_button_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors
                                          .danger_button_text_color,
                                      expression:
                                        "themeColors.danger_button_text_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ffffff"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.danger_button_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "danger_button_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "section" }, [
                        _c("h3", [_vm._v("Border Colors")]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", { attrs: { for: "border_color" } }, [
                                _vm._v("Border Color")
                              ]),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.border_color,
                                      expression: "themeColors.border_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: { type: "color", id: "border_color" },
                                  domProps: {
                                    value: _vm.themeColors.border_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "border_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.border_color,
                                      expression: "themeColors.border_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#dee2e6"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.border_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "border_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "border_hover_color" } },
                                [_vm._v("Border Hover Color")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.border_hover_color,
                                      expression:
                                        "themeColors.border_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "border_hover_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.border_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "border_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.border_hover_color,
                                      expression:
                                        "themeColors.border_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#adb5bd"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.border_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "border_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "section" }, [
                        _c("h3", [_vm._v("Input Box Colors")]),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "input_box_border_color" } },
                                [_vm._v("Input Box Border")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_border_color,
                                      expression:
                                        "themeColors.input_box_border_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "input_box_border_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.input_box_border_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_border_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_border_color,
                                      expression:
                                        "themeColors.input_box_border_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ced4da"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.input_box_border_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_border_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "input_box_text_color" } },
                                [_vm._v("Input Box Text")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_text_color,
                                      expression:
                                        "themeColors.input_box_text_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "input_box_text_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.input_box_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_text_color,
                                      expression:
                                        "themeColors.input_box_text_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#495057"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.input_box_text_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_text_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "input_box_bg_color" } },
                                [_vm._v("Input Box Background")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.input_box_bg_color,
                                      expression:
                                        "themeColors.input_box_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "input_box_bg_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.input_box_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.themeColors.input_box_bg_color,
                                      expression:
                                        "themeColors.input_box_bg_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#ffffff"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.input_box_bg_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_bg_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "input_box_hover_color" } },
                                [_vm._v("Input Box Hover")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_hover_color,
                                      expression:
                                        "themeColors.input_box_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "input_box_hover_color"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.input_box_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_hover_color,
                                      expression:
                                        "themeColors.input_box_hover_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#e9ecef"
                                  },
                                  domProps: {
                                    value: _vm.themeColors.input_box_hover_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_hover_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-md-3" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                { attrs: { for: "input_box_active_color" } },
                                [_vm._v("Input Box Active")]
                              ),
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_active_color,
                                      expression:
                                        "themeColors.input_box_active_color"
                                    }
                                  ],
                                  staticClass: "form-control color-picker",
                                  attrs: {
                                    type: "color",
                                    id: "input_box_active_color"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.input_box_active_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_active_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.themeColors.input_box_active_color,
                                      expression:
                                        "themeColors.input_box_active_color"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "#007bff"
                                  },
                                  domProps: {
                                    value:
                                      _vm.themeColors.input_box_active_color
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.themeColors,
                                        "input_box_active_color",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "row mt-4" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn-lg-green",
                              attrs: { type: "submit", disabled: _vm.saving }
                            },
                            [
                              _vm.saving
                                ? _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm mr-2",
                                    attrs: { role: "status" }
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(
                                    _vm.saving
                                      ? "Saving..."
                                      : "Save Theme Colors"
                                  ) +
                                  "\n                                    "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h1", [_vm._v("Brand Theme Settings")]),
      _c("p", [_vm._v("Customize your brand's theme colors")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }